// import router from '../router'
import axios from '../axios'
import axiosr8 from '../axiosr8'

var AuthenticationService = function () {
  var user = null
  var refreshToken = null
  var validUntilUtc = new Date()
  var authenticated = false
  var disclaimerAccepted = false

  var createGuid = function () {
    function _p8 (s) {
      var p = (Math.random().toString(16) + '000000000').substr(2, 8)
      return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p
    }
    return _p8() + _p8(true) + _p8(true) + _p8()
  }
  var getQuerystringParameter = function (querystring) {
    var sPageURL = window.location.search.substring(1)
    var sURLVariables = sPageURL.split('&')
    for (var i = 0; i < sURLVariables.length; i++) {
      var sParameterName = sURLVariables[i].split('=')
      if (sParameterName[0] === querystring) {
        return sParameterName[1]
      }
    }
  }

  var isRefreshing = false
  var acquireAccessTokenAndRefreshTokenByRefreshToken = (_refreshToken) => {
    if (isRefreshing) return Promise.resolve(authenticated)
    isRefreshing = true
    return new Promise(function (resolve, reject) {
      var bodyFormData = new FormData()
      bodyFormData.append('refreshToken', _refreshToken)
      axios.post('authSSO/getAccessAndRefreshTokenByRefreshToken', bodyFormData, {
        timeout: 10000
      })
        .then(response => {
          user = response.data.User
          refreshToken = response.data.RefreshToken
          validUntilUtc = new Date(response.data.ValidTill)
          disclaimerAccepted = response.data.DisclaimerAccepted
          axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.AccessToken
          axiosr8.defaults.headers.common.Authorization = 'Bearer ' + response.data.AccessToken
          localStorage.setItem('refreshTokenPoss' + process.env.NODE_ENV, refreshToken)
          startRefreshTokenTimer()
          authenticated = true
          resolve(true)
        })
        .catch(e => {
          localStorage.removeItem('refreshTokenPoss' + process.env.NODE_ENV)
          resolve(false)
        })
        .finally(() => {
          isRefreshing = false
        })
    })
  }

  var currentTimer = null
  var startRefreshTokenTimer = function () {
    clearTimeout(currentTimer)
    const MIN = 2500 // 2.5 sec
    const MAX = 900000 // 15 minutes
    let validInSeconds = (validUntilUtc.getTime() - (new Date()).getTime()) / 1000
    currentTimer = setTimeout(function () {
      var token = localStorage.getItem('refreshTokenPoss' + process.env.NODE_ENV)
      if (!token) return
      acquireAccessTokenAndRefreshTokenByRefreshToken(token).then(success => {
        if (!success) {
          authenticated = false
          var nonce = createGuid()
          let ssoUrl = process.env.VUE_APP_SSO_OAUTH2_URL + '?client_id=' + process.env.VUE_APP_SSO_CLIENT_ID + '&response_type=code&redirect_uri=' + process.env.VUE_APP_SSO_REDIRECT_URL + '&response_mode=query&scope=' + process.env.VUE_APP_SSO_SCOPE + '&state=1&nonce=' + nonce
          window.location.replace(ssoUrl)
        }
      })
    // Refresh at 75% of token lifetime (seconds * 0.75 * 1000ms), clamped between MIN and MAX
    }, Math.min(Math.max(validInSeconds * 750, MIN), MAX))
  }

  return {
    getUser: function () {
      return user
    },
    isAuthenticated () {
      return authenticated
    },
    isDisclaimerAccepted () {
      return disclaimerAccepted
    },
    logOut () {
      authenticated = false
      localStorage.removeItem('refreshTokenPoss' + process.env.NODE_ENV)
      let logoutUrl = process.env.VUE_APP_SSO_ROOT_URL + '/Account/Logout'
      window.location.replace(logoutUrl)
    },
    acceptDisclaimerSso: function (userName) {
      return new Promise(function (resolve, reject) {
        axios.post('authSSO/acceptdisclaimerSso', userName)
          .then(response => {
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async ensureAuthenticated () {
      // possible situations:
      // 1. We're redirected back here from idp with an authorizationcode in the url => acquire access token with authorization code
      // 2. There is a refresh_token present => acquire access token with refresh_token
      // 3. None off the above => redirect to idp with authorize request

      // 1
      var authorizationCode = getQuerystringParameter('code')
      if (authorizationCode) {
        return this.handleSsoRedirect(authorizationCode)
      }

      // 2
      if (localStorage.getItem('refreshTokenPoss' + process.env.NODE_ENV)) {
        let success = await acquireAccessTokenAndRefreshTokenByRefreshToken(localStorage.getItem('refreshTokenPoss' + process.env.NODE_ENV))
        if (success) {
          return true
        }
      }

      // 3
      authenticated = false
      return this.loginAtIdentityProvider()
    },
    async loginAtIdentityProvider () {
      // Save the current hash route so we can restore it after SSO redirect
      var currentHash = window.location.hash
      if (currentHash && currentHash.length > 1) {
        // Strip the leading '#' to get the router path (e.g. '#/switch/55947' becomes '/switch/55947')
        localStorage.setItem('pendingRoute', currentHash.substring(1))
      }
      // redirect to identity provider
      var nonce = createGuid()
      let ssoUrl = process.env.VUE_APP_SSO_OAUTH2_URL + '?client_id=' + process.env.VUE_APP_SSO_CLIENT_ID + '&response_type=code&redirect_uri=' + process.env.VUE_APP_SSO_REDIRECT_URL + '&response_mode=query&scope=' + process.env.VUE_APP_SSO_SCOPE + '&state=1&nonce=' + nonce
      window.location.replace(ssoUrl)
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(false)
        }, 30000)
      })
    },
    acquireAccessAndRefreshTokenByAuthorizationCode (authorizationCode) {
      return new Promise(function (resolve, reject) {
        var bodyFormData = new FormData()
        bodyFormData.append('authorizationCode', authorizationCode)
        bodyFormData.append('ssoRedirectUrl', process.env.VUE_APP_SSO_REDIRECT_URL)
        let axiosRef = axios
        let axiosRefR8 = axiosr8
        axios.post('authSSO/GetAccessAndRefreshTokenByAuthorizationCode', bodyFormData, {
          timeout: 10000
        })
          .then(response => {
            user = response.data.User
            refreshToken = response.data.RefreshToken
            validUntilUtc = new Date(response.data.ValidTill)
            disclaimerAccepted = response.data.DisclaimerAccepted
            axiosRef.defaults.headers.common.Authorization = 'Bearer ' + response.data.AccessToken
            axiosRefR8.defaults.headers.common.Authorization = 'Bearer ' + response.data.AccessToken
            localStorage.setItem('refreshTokenPoss' + process.env.NODE_ENV, refreshToken)
            startRefreshTokenTimer()
            authenticated = true
            resolve(true)
          })
          .catch(e => {
            localStorage.removeItem('refreshTokenPoss' + process.env.NODE_ENV)
            resolve(false)
            // reject(e)
          })
      })
    },
    async handleSsoRedirect (authorizationCode) {
      if (window.location.href.indexOf('?') > -1) {
        history.pushState('', document.title, window.location.pathname)
      }
      return this.acquireAccessAndRefreshTokenByAuthorizationCode(authorizationCode)
    }
  }
}

export default new AuthenticationService()



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js